<template>
   <hic-dialog :title="title" :visible="visible" @close="cancel" width="37rem" top="10vh">
    <el-main style="padding: 0 10px">
      <el-form class="left" ref="info" :rules="rules" :inline="true" :model="detailValue" label-width="8rem">
        <el-row>
          <el-col :span="24">
            <el-form-item label="手术时间">
              <el-date-picker style="width: 23rem" v-model="detailValue.date" type="datetimerange" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期"></el-date-picker>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </el-main>
    <div slot="footer">
      <el-button @click="$emit('update:visible', false)">取消</el-button>
      <el-button type="primary" @click="$emit('update:visible', false)" class="left-pad">提交</el-button>
    </div>
  </hic-dialog>
</template>
<script>
import api from './api';
import { mapGetters } from 'sw-hic';
export default {
  props: {
    visible: Boolean,
    title: String,
  },
  data() {
    return {
      detailValue: {},
    };
  },
  computed: {
    ...mapGetters(['dict', 'getDict', 'Enum', 'dictEnum', 'user', 'permission']),
  },
  filters: {},
  watch: {},
  mounted() {},
  methods: {
    async queryPatient() {},
    lookHistory() {
      this.meta.showOper = true;
    },
    submit(type) {},

    addCounts(id) {},
    cancel() {
      this.$emit('update:visible', false);
    },
    addFloat(num1, num2) {},
  },
};
</script>

<style scoped></style>
